<template>
  <div>
    <b-field label="Product Code" horizontal :message="codeMessage" :type="`${codeMessage ? 'is-danger' : ''}`">
      <b-input v-model="code" />
    </b-field>

    <b-field label="Title" horizontal>
      <b-input v-model="title" />
    </b-field>

    <b-field label="Settings" grouped horizontal>
      <b-switch v-model="isActive">Active</b-switch>
      <b-switch v-if="!hideTSS" v-model="isTSS">TSS</b-switch>
      <p v-if="!hideTSS" class="help">Ignore TSS if unfamiliar with it.</p>
    </b-field>

    <b-field v-if="isTSS" label="TSS Password" horizontal>
      <b-input v-model="pw" />
    </b-field>

    <b-field label="Elevator Pitch" message="Used for quick pitch in members area." horizontal>
      <b-input type="textarea" v-model="copy" />
    </b-field>

    <b-field horizontal>
      <b-button @click="addService" :disabled="loading" :loading="loading" type="is-success">Create Service</b-button>
    </b-field>
  </div>
</template>

<script>
import {updateService} from '@/utils/api';

export default {
  data() {
    return {
      hideTSS: process.env.VUE_APP_NO_TSS,
      loading: false,
      code: '',
      codeMessage: '',
      pw: '123456',
      title: '',
      isActive: false,
      isTSS: false,
      paymentLinks: [],
      reviews: [],
      copy: '',
      hideClosedPicks: false,
    }
  },
  methods: {
    addService: async function () {
      let {code, pw, title, isActive, isTSS, paymentLinks, reviews, copy, hideClosedPicks} = this;

      if (!code) {
        return this.codeMessage = 'Code is required'
      }

      this.loading = true;

      let res = await updateService({
        id: code,
        edits: {
          pw,
          title,
          isActive,
          isTSS,
          paymentLinks,
          reviews,
          copy,
          hideClosedPicks
        }
      })

      if (res.ok) {
        this.loading = false;
        this.$emit('updated', (await res.json()));
      }
    }
  }
}
</script>